<template>
  <div class="vx-row">
    <div class="vx-col w-full mb-base">
      <form>
        <vx-card>
          <vs-row vs-w="12" class="mb-5">
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="1"
              vs-sm="4"
              vs-xs="12"
            >
              <vs-button
                @click="goBack"
                color="danger"
                type="border"
                icon="keyboard_backspace"
                >Back</vs-button
              >
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="9"
              vs-sm="4"
              vs-xs="12"
            >
              <h3>Add a New Elomark User</h3>
            </vs-col>
            <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="2"
              vs-sm="4"
              vs-xs="12"
            >
            </vs-col>
          </vs-row>
          <vs-divider class="m-5" />
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>First Name:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="first_name"
                v-model="users.first_name"
                v-validate="'required'"
                data-vv-as="First Name"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('first_name')"
              >{{ errors.first("first_name") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Surname:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="surname"
                v-model="users.surname"
                v-validate="'required'"
                data-vv-as="Surname"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('surname')"
              >{{ errors.first("surname") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Job Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="job_role"
                v-model="users.job_role"
                data-vv-as="Job Role"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('job_role')"
              >{{ errors.first("job_role") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Desk Phone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="desk_phone"
                v-model="users.desk_phone"
                data-vv-as="Desk Phone"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('desk_phone')"
              >{{ errors.first("desk_phone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Softphone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="softphone"
                v-model="users.softphone"
                data-vv-as="Softphone"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('softphone')"
              >{{ errors.first("softphone") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Mobile No.:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="mobile_no"
                v-model="users.mobile_no"
                data-vv-as="Mobile No."
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('mobile_no')"
              >{{ errors.first("mobile_no") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 1:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_1"
                v-model="users.alternate_phone_1"
                data-vv-as="Alternate Phone 1"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_1')"
              >{{ errors.first("alternate_phone_1") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Alternate Phone 2:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="alternate_phone_2"
                v-model="users.alternate_phone_2"
                data-vv-as="Alternate Phone 2"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('alternate_phone_2')"
              >{{ errors.first("alternate_phone_2") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>User Status:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                v-validate="'required'"
                required
                label="user_status"
                name="selected_user_status"
                :options="userStatusList"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.selected_user_status"
                data-vv-as="User Status"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('selected_user_status')"
              >{{ errors.first("selected_user_status") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Role:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                v-validate="'required'"
                required
                name="role"
                label="role"
                :options="elomarkRoleTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.role"
                data-vv-as="User Role"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('role')"
              >{{ errors.first("role") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Manager:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                label="full_name"
                :options="elomarkManagers"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.selected_manager"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 1:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_1"
                v-model="users.address_1"
                data-vv-as="Address 1"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('address_1')"
              >{{ errors.first("address_1") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 2:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_2"
                v-model="users.address_2"
                data-vv-as="Address 2"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Address 3:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="address_3"
                v-model="users.address_3"
                data-vv-as="Address 3"
              />
            </div>
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>City:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="city"
                v-model="users.city"
                data-vv-as="City"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('city')"
              >{{ errors.first("city") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>County:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="county"
                v-model="users.county"
                data-vv-as="County"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('county')"
              >{{ errors.first("county") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Country:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <AccountAutocomplete
                class="searchbox"
                :list="getCountries"
                :chosen="head_office_country"
                :searchOn="'head_office_country'"
              ></AccountAutocomplete>
            </div>
              <span
              class="text-danger text-sm mt-2 ml-16"
              v-if="country_required"
              >{{ country_required }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Postcode:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="postcode"
                v-model="users.postcode"
                data-vv-as="postcode"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('postcode')"
              >{{ errors.first("postcode") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Rate:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-input
                class="w-full"
                name="rate"
                v-model="users.rate"
                data-vv-as="rate"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('rate')"
              >{{ errors.first("rate") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Date Of Birth:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <flat-pickr
                class="flat-pick"
                :config="configdateTimePicker"
                v-model="users.dob"
                name="dob"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('dob')"
              >{{ errors.first("dob") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Contract Start Date:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <flat-pickr
                class="flat-pick"
                :config="configdateTimePicker"
                v-model="users.contract_commencement_date"
                name="contract_commencement_date"
                v-validate="'required'"
              />
            </div>
            <span
              class="text-danger text-sm mt-2"
              v-show="errors.has('contract_commencement_date')"
              >{{ errors.first("contract_commencement_date") }}</span
            >
          </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Timezone:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <TimezoneAutocomplete
                class="searchbox mb-5"
                :list="getTimezones"
                :searchOn="'timezone'"
                @event-name="handleTimeZoneSelected"
              ></TimezoneAutocomplete>
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-if="timezone_required"
              >{{ timezone_required }}</span
            >
          </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>User Type:</span>
            </div>
            <div class="vx-col sm:w-1/2 w-full">
              <v-select
                name="user_type"
                label="usertype"
                :options="allUserTypes"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="users.user_type"
                v-validate="'required'"
                data-vv-as="User Type"
              />
              <div class="mt-5" v-if="users.isContractor == 'y'">
                <span>Is associated with company?</span>
                <vs-switch
                  class="mt-3"
                  vs-icon-on="check_box"
                  vs-icon-off="block"
                  v-model="users.hasCompanyId"
                >
                  <span slot="on">YES</span>
                  <span slot="off">NO</span>
                </vs-switch>
              </div>
            </div>

            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('user_type')"
              >{{ errors.first("user_type") }}</span
            >
          </vs-col>
          <vs-col vs-type="flex" vs-w="6" class="mb-6"> </vs-col>

          <vs-col vs-type="flex" vs-w="6" class="mb-6">
            <template v-if="users.hasCompanyId">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Company:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <AccountAutocomplete
                  :key="companySearchComponentKey"
                  class="searchbox"
                  :list="searchAccount"
                  :searchOn="'company_or_registration_no'"
                  @event-name="handleChildEvent"
                ></AccountAutocomplete>
              </div>
            </template>
          </vs-col>
                    <vs-col vs-type="flex" vs-w="6" class="mb-6"> </vs-col>

          <template v-for="(language, index) in users.languages">
             <vs-col vs-type="flex" vs-w="6" class="mb-6" :key="index">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Language:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <LanguageAutocomplete
                class="searchbox"
                :list="getLanguages"
                :searchOn="'language'"
                @event-name="handleLanguageSelected(index)"
              ></LanguageAutocomplete>
            </div>
               <div class="vx-col sm:w-1/3 w-full ml-3">
               <v-select
                name="language_compentency"
                label="name"
                :options="languageCompetency"
                :dir="$vs.rtl ? 'rtl' : 'ltr'"
                v-model="language.language_competency_name"
                data-vv-as="User Compentency"
              />

            </div>
             <feather-icon
                  class="ml-5"
                  icon="XIcon"
                  svgClasses="h-4 w-4"
                  v-on:click="removeLanguage(index)"
                />
          </vs-col>
            <!-- <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Language:</span>
              </div>
              <div class="vx-col sm:w-1/2 w-full">
                <LanguageAutocomplete
                  class="searchbox"
                  :list="getLanguages"
                  :searchOn="'language'"
                  @event-name="handleLanguageSelected(index)"
                ></LanguageAutocomplete>
              </div>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" class="mb-6">
              <div class="vx-col sm:w-1/6 w-full">
                <span>Language Competency:</span>
              </div>

              <div class="vx-col sm:w-1/2 w-full">
                <v-select
                  name="language_compentency"
                  label="name"
                  :options="languageCompetency"
                  :dir="$vs.rtl ? 'rtl' : 'ltr'"
                  v-model="language.language_compentency"
                  data-vv-as="User Compentency"
                />
              </div>
              <feather-icon
                class="ml-5"
                icon="XIcon"
                svgClasses="h-4 w-4"
                v-on:click="removeLanguage(index)"
              />
            </vs-col> -->
          </template>
                  <vs-col vs-type="flex" vs-w="12" class="mb-6">
          <vs-col
              vs-type="flex"
              vs-justify="center"
              vs-align="center"
              vs-lg="8"
              vs-sm="12"
              vs-xs="12"
            >
               <vs-button class="mt-5 mb-5" color="danger" @click="selectAnotherLanguage()"
                    >Add More language</vs-button
                  >
            </vs-col>
           </vs-col>
          <span
              class="text-danger text-sm mt-2 ml-16"
              v-if="language_required"
              >{{ language_required }}</span
            >
          
        

          <vs-divider class="m-5" />

          <!-- Head Office -->
          <h5 class="mb-5">Login Details</h5>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Email Address:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <input type="text" name="email" class="w-full custom-input" v-model="users.email" v-validate="'email|required'" data-vv-as="Email Address"/>

              <!-- <vs-input
                class="w-full"
                v-model="users.email"
                name="email"
                v-validate="'email|required'"
                data-vv-as="Email Address"
              /> -->
            </div>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('email')"
              >{{ errors.first("email") }}</span
            >
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full">
              <span>Password:</span>
            </div>
            <div class="vx-col sm:w-1/3 w-full">
              <!-- <vs-input
                :type="type"
                class="w-full"
                name="password"
                v-model="users.password"
                v-validate="'required'"
                data-vv-as="Password"
              /> -->

              <input autocomplete="new-password" :type="type" name="password" class="w-full custom-input" v-model="users.password" v-validate="'required'" data-vv-as="Password"/>

            </div>
           
            <i
              style="border-left:0px;"
              @click="type = type == 'password' ? 'text' : 'password'"
              :class="[
                type == 'password'
                  ? 'vs-icon vs-input--icon-custom vs-input--icon feather icon icon-eye icon-after'
                  : 'vs-icon vs-input--icon vs-input--icon-custom feather icon icon-eye-off icon-after'
              ]"
            ></i>
            <span
              class="text-danger text-sm mt-2 ml-16"
              v-show="errors.has('password')"
              >{{ errors.first("password") }}</span
            >
          </div>
          <vs-divider class="m-5" />
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/6 w-full"></div>
            <div class="vx-col sm:w-1/2 w-full">
              <vs-button class="mr-3 mb-2" @click.prevent="submitForm"
                >Submit</vs-button
              >
            </div>
          </div>
        </vx-card>
      </form>
    </div>
  </div>
</template>
<script>
// Store Module
import defineAbilitiesFor from "@/config/abilities";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
import moduleElomarkUserManagement from "@/store/elomark-user-management/moduleElomarkUserManagement.js";
import ElomarkUserAutocomplete from "@/components/autocomplete/ElomarkUserAutocomplete.vue";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleUserTypeManagement from "@/store/usertype-management/moduleUserTypeManagement.js";
import TimezoneAutocomplete from "@/components/autocomplete/TimezoneAutocomplete.vue";
import LanguageAutocomplete from "@/components/autocomplete/LanguageAutocomplete.vue";
import vSelect from "vue-select";
import moment from "moment";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
export default {
  data() {
    return {
      head_office_country: null,
      language_required:null,
      timezone_required:null,
      country_required:null,
      counter: 0,
      languageCompetency: [],
      abilities: null,
      type: "password",
      companySearchComponentKey: 0,
      allUserTypes: [],
      allTimezones: [],
      elomarkManagers: [],
      elomarkRoleTypes: [],
      userStatusList: [],
      users: {
        isContractor: "n",
        first_name: null,
        surname: null,
        desk_phone: null,
        softphone: null,
        mobile_no: null,
        alternate_phone_1: null,
        alternate_phone_2: null,
        job_role: null,
        email: null,
        password: null,
        role: null,
        address_1: null,
        address_2: null,
        address_3: null,
        country: null,
        postcode: null,
        timezone: null,
        county: null,
        city: null,
        user_type: null,
        company_id: null,
        selected_user_status: null,
        selected_role: null,
        selected_manager: null,
        manager: null,
        languages: [
          {
            language_id: null,
            language_compentency: null,
            id: 0
          }
        ],
        rate: null,
        dob: null,
        contract_commencement_date: null
      },
      configdateTimePicker: {
        enableTime: false,
        // dateFormat: "Y-m-d",
        format: "d/m/Y",
        altFormat: "d/m/Y",
        altInput: true
      }
    };
  },
  components: {
    "v-select": vSelect,
    moduleElomarkUserManagement,
    ElomarkUserAutocomplete,
    AccountAutocomplete,
    moduleUserTypeManagement,
    TimezoneAutocomplete,
    LanguageAutocomplete,
    flatPickr
  },
  watch: {
    "users.user_type"(val) {
      if (val) {
        if (val.usertype == "Contractor") {
          this.users.isContractor = "y";
        } else {
          this.users.isContractor = "n";
          this.users.hasCompanyId = false;
        }
      }
    },
  },
  created() {
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });
    if (!moduleElomarkUserManagement.isRegistered) {
      this.$store.registerModule(
        "elomarkUsersManagement",
        moduleElomarkUserManagement
      );
      moduleElomarkUserManagement.isRegistered = true;
    }

    if (!moduleAccountsManagement.isRegistered) {
      this.$store.registerModule(
        "accountsManagement",
        moduleAccountsManagement
      );
      moduleAccountsManagement.isRegistered = true;
    }

    if (!moduleUserTypeManagement.isRegistered) {
      this.$store.registerModule(
        "usertypesManagement",
        moduleUserTypeManagement
      );
      moduleUserTypeManagement.isRegistered = true;
    }
  },
  mounted() {
    this.getElomarkRoleTypes();
    this.getElomarkManagers();
    this.getElomarkUserStatus();
    this.getUserTypes();
    this.getLanguageCompetency();
    // this.getVerticals();
  },
  methods: {
    handleChildEvent() {
      var selected_account = moduleAccountsManagement.state.accounts.datas;
      this.users.company_id = selected_account[0].id;
    },
    goBack: function() {
      this.$router.go(-1);
    },
    removeLanguage(index) {
      this.users.languages.splice(index, 1);
    },
    selectAnotherLanguage() {
      this.users.languages.push({
        id: ++this.counter,
        language_id: null,
        language_compentency: null
      });
      this.counter++;
    },
    searchAccount(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleAccountsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    handleTimeZoneSelected() {
      var selected_time_zone =
        moduleElomarkUserManagement.state.selected_time_zone;
      this.users.timezone = selected_time_zone.id;
      this.timezone_required = null

    },
    handleLanguageSelected(index) {
      var selected_language =
        moduleElomarkUserManagement.state.selected_language;
      this.users.languages[index]["language_id"] = selected_language.id;
      this.language_required = null
    },
    submitForm() {


      this.$validator.validateAll().then(result => {

             
      if(typeof moduleAccountsManagement.head_office_country_selected == 'undefined'){
       this.country_required = "The country field is required"
       result = false
      }else{
        this.country_required = null
        result = true
      }

      if(this.users.timezone == null){
       this.timezone_required = "The timezone field is required"
       result = false
      }else{
        this.timezone_required = null
        result = true
      }

      if(this.users.languages[0].language_id == null || this.users.languages[0].language_competency_name['id'] == null){
        this.language_required = "At least one language is required.Please choose language and language competency."
         result = false
      }else{
         this.language_required = null
         result = true
      }

        if (moduleAccountsManagement.head_office_country_selected) {
          this.users.country =
            moduleAccountsManagement.head_office_country_selected.id;
        } else {
          this.users.country = null;
        }

        if (result) {
          if (this.users.role != null) {
            this.users.selected_role = this.users.role;
          }
          if (this.users.selected_manager != null) {
            this.users.manager = this.users.selected_manager.id;
          }
          if (this.users.dob != null) {
            this.users.dob = moment(this.users.dob).format("YYYY-MM-DD");
          }
          if (this.users.contract_commencement_date != null) {
            this.users.contract_commencement_date = moment(
              this.users.contract_commencement_date
            ).format("YYYY-MM-DD");
          }

          this.addElomarkUsers();
          // if form have no errors
        } else {
          // form have errors
        }
      });
    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          let data = moduleAccountsManagement.state.countries;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name_1
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    addElomarkUsers() {
      this.$store
        .dispatch("elomarkUsersManagement/addElomarkUser", this.users)
        .then(res => {
          if (res.data.status == "fail") {
            this.$vs.notify({
              color: "danger",
              title: "User Exists",
              text: res.data.message
            });
          } else {
            this.$vs.notify({
              color: "success",
              title: "Elomark User Added",
              text: "The elomark user was added successfully"
            });
            this.$router.push({ path: "/elomark-users" });
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkRoleTypes() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkRoleTypes")
        .then(res => {
          this.elomarkRoleTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkUserStatus() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkUserStatus")
        .then(res => {
          this.userStatusList = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getElomarkManagers() {
      this.$store
        .dispatch("elomarkUsersManagement/getElomarkManagers")
        .then(res => {
          this.elomarkManagers = res.data;
          this.elomarkManagers = this.elomarkManagers.filter(function(ele) {
            ele.full_name = ele.first_name + " " + ele.surname;
            return ele;
          });
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getTimezones(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getTimezones", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_time_zone;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].label
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getLanguages(inputValue) {
      return this.$store
        .dispatch("elomarkUsersManagement/getAllLanguages", inputValue)
        .then(response => {
          let data = moduleElomarkUserManagement.state.all_languages;
          // console.log(data);
          let mappedArray = [];
          for (const property in data) {
            mappedArray.push({
              id: data[property].id,
              name: data[property].name
            });
          }
          return mappedArray;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getUserTypes() {
      this.$store
        .dispatch("usertypesManagement/fetchAllTypes")
        .then(res => {
          this.allUserTypes = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getLanguageCompetency() {
      this.$store
        .dispatch("elomarkUsersManagement/fetchAllLanguageCompetency")
        .then(res => {
          this.languageCompetency = res.data;
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    }
  }
};
</script>
<style>
.flat-pick {
  padding: 0.7rem;
  font-size: 1rem;
  color: #626262;
  cursor: pointer;
}
</style>
<style scoped>
.removeButton {
  cursor: pointer;
}

[dir="ltr"] .vs-input--icon.feather {
  padding: 0.9rem 2rem 0.2rem 0.2rem;
  position: relative;
}

.vs-input--icon-custom.feather {
  top: auto;
  position: absolute;

}


.custom-input{
  border: 1px solid rgba(0, 0, 0, 0.2);
  padding: 0.7rem !important;
  font-size: 1rem !important;
}
</style>
